import React from "react";
import "./SearchProgressBar.css";

/**
 * Barra de progreso indeterminada para la búsqueda (feedback QA/Ricardo).
 * Se muestra mientras la búsqueda está en curso (`isFetching`), dando feedback
 * visible cuando la consulta tarda. Es puramente presentacional.
 */
const SearchProgressBar = () => (
  <div
    className="search-progress-bar"
    role="progressbar"
    aria-label="Buscando…"
    aria-busy="true"
  >
    <div className="search-progress-bar__indicator" />
  </div>
);

export default SearchProgressBar;
